/* facts-library.js · FACTS Wirkstoff-Bibliothek · v2 (Bloecke) · 2026-09-03
   Verhalten der Section facts-library: Kategorie-Filter, Lade (Steckbrief),
   Versorgungs-Leisten, Grenzen, Aussagen, Quellen. Je Wirkstoff: Kurztexte und
   Bild aus der Kachel (Block im Theme-Editor), Zahlen, Aussagen und Quellen aus
   dem type=application/json Datenblock, verknuepft ueber den Daten-Schluessel.
   Im Theme-Editor oeffnet ein gewaehlter Block seinen Steckbrief.
   Bewegung: Register B (transform/opacity), reduced-motion respektiert. */
(function () {
  'use strict';
  var REF_TOLERANCE = 0.98; /* Rundungsregel 2026-09-02: 98 % gelten als erreicht */
  var CHECK = '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6.5l2.6 2.5L10 3.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(v) {
    if (v == null || isNaN(v)) return '';
    var n = Number(v);
    var d = n >= 100 ? 0 : n >= 10 ? 1 : 2;
    var s = n.toFixed(d);
    if (s.indexOf('.') >= 0) s = s.replace(/0+$/, '').replace(/\.$/, '');
    return /^en(?:-|$)/i.test(document.documentElement.lang) ? s : s.replace('.', ',');
  }
  function amt(v, unit) { return fmt(v) + ' ' + unit; }
  function pct(v, max) { return Math.max(0, Math.min(100, v / max * 100)); }
  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  /* Naechster Frame mit Fallback: rAF pausiert in verdeckten Tabs, der Timer nicht. */
  function nextFrame(fn) { var done = false; var run = function () { if (!done) { done = true; fn(); } }; requestAnimationFrame(function () { requestAnimationFrame(run); }); setTimeout(run, 120); }

  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    document.documentElement.style.overflow = ''; /* nach einem Editor-Re-Render nie gesperrt bleiben */
    var data, L;
    try {
      data = JSON.parse(root.querySelector('[data-fli-data]').textContent);
      L = JSON.parse(root.querySelector('[data-fli-labels]').textContent);
    } catch (e) { return; }

    var showDaily = root.dataset.showDaily === 'true';
    var sourcesMode = root.dataset.sourcesMode || 'bis_2b';
    var sex = root.dataset.preselect === 'male' ? 'male' : 'female';
    var dbByKey = {}, catSing = {};
    data.categories.forEach(function (c) { catSing[c.key] = c.sing; });
    (data.items || []).forEach(function (o) { dbByKey[o.key] = o; });

    var grid = root.querySelector('[data-fli-grid]');
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-fli-tile]'));

    /* ---------- Wirkstoffe: Block (Kachel) + Datenbank (Zahlen, Aussagen, Quellen) ---------- */
    var items = [], byKey = {};
    function lines(s) { return String(s || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); }
    tiles.forEach(function (t, i) {
      var key = t.dataset.fliTile;
      if (byKey[key]) { key = key + '-' + (i + 1); t.dataset.fliTile = key; }
      var db = dbByKey[t.dataset.fliTile] || dbByKey[key] || null;
      var o = {
        key: key, inDb: !!db,
        name: t.dataset.name || key, sub: t.dataset.sub || '', cat: t.dataset.cat || (db && db.cat) || '',
        form: t.dataset.form || '', what: t.dataset.what || '', role: t.dataset.role || '', safety: lines(t.dataset.safety),
        products: (db && db.products) || [], doseNote: db && db.doseNote, supply: db && db.supply,
        claims: (db && db.claims) || [], claimsNote: db && db.claimsNote, onhold: db && db.onhold, sources: (db && db.sources) || []
      };
      o.catLabel = catSing[o.cat] || '';
      o.claimState = o.claims.length ? 'authorised' : 'none';
      if (o.claimState === 'none') o.leer = L.leer.replace('{name}', o.name);
      byKey[key] = o; items.push(o);
    });
    var chips = root.querySelector('[data-fli-chips]');
    var empty = root.querySelector('[data-fli-empty]');
    var drawer = root.querySelector('[data-fli-drawer]');
    var backdrop = root.querySelector('[data-fli-backdrop]');
    var scroll = root.querySelector('[data-fli-scroll]');
    var dhero = root.querySelector('[data-fli-dhero]');
    var dcat = root.querySelector('[data-fli-dcat]');
    var dname = root.querySelector('[data-fli-dname]');
    var dform = root.querySelector('[data-fli-dform]');
    var dcontent = root.querySelector('[data-fli-dcontent]');
    var openKey = null, lastFocus = null, currentCat = 'all', pickKey = {};

    /* ---------- Kacheln: "in N Systemen" (Kachel ohne Produkt nur verbergen, wenn die Datenbank sie kennt) ---------- */
    tiles = tiles.filter(function (t) {
      var o = byKey[t.dataset.fliTile];
      var n = products(o).length;
      if (!n && o.inDb) { t.hidden = true; t.dataset.gone = '1'; return false; }
      var el = t.querySelector('[data-fli-tile-in]');
      if (el) el.textContent = !n ? '' : (n === 1 ? L.inOne : L.inMany.replace('{count}', n));
      return true;
    });

    /* ---------- Kennzahlen (aus den sichtbaren Kacheln, nicht aus der Datenbank) ---------- */
    var claimsN = 0; tiles.forEach(function (t) { claimsN += byKey[t.dataset.fliTile].claims.length; });
    var stats = { ingredients: tiles.length, categories: 0, claims: claimsN };
    var catN = {};
    tiles.forEach(function (t) { catN[t.dataset.cat] = (catN[t.dataset.cat] || 0) + 1; });
    stats.categories = Object.keys(catN).length;
    var statEls = Array.prototype.slice.call(root.querySelectorAll('[data-fli-stat]'));
    function setStatValues(progress) {
      statEls.forEach(function (el) {
        var target = stats[el.dataset.fliStat];
        if (target == null) return;
        el.textContent = Math.round(target * progress);
      });
    }
    function animateStats() {
      if (!statEls.length || reduced) { setStatValues(1); return; }
      setStatValues(0);
      var statsWrap = root.querySelector('.fli__stats');
      var started = false;
      function start() {
        if (started) return;
        started = true;
        var startAt = null;
        var duration = 1100;
        function frame(now) {
          if (startAt == null) startAt = now;
          var progress = Math.min(1, (now - startAt) / duration);
          var eased = 1 - Math.pow(1 - progress, 3);
          setStatValues(eased);
          if (progress < 1) requestAnimationFrame(frame);
          else setStatValues(1);
        }
        requestAnimationFrame(frame);
      }
      if (!statsWrap || !('IntersectionObserver' in window)) { start(); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        start();
      }, { threshold: 0.3 });
      observer.observe(statsWrap);
    }
    animateStats();

    /* ---------- Filter ---------- */
    var allN = chips.querySelector('[data-fli-catn="all"]'); if (allN) allN.textContent = tiles.length;
    data.categories.forEach(function (c) {
      if (!catN[c.key]) return;
      var b = h('button', 'fli__chip', esc(c.label) + ' <span class="fli__chip-n">' + catN[c.key] + '</span>');
      b.type = 'button'; b.setAttribute('aria-pressed', 'false'); b.dataset.fliCat = c.key;
      chips.appendChild(b);
    });
    function visibleTiles() { return tiles.filter(function (t) { return !t.hidden; }); }
    function applyFilter(cat) {
      currentCat = cat;
      Array.prototype.forEach.call(chips.querySelectorAll('[data-fli-cat]'), function (b) { b.setAttribute('aria-pressed', b.dataset.fliCat === cat ? 'true' : 'false'); });
      var shown = 0;
      tiles.forEach(function (t) {
        var show = cat === 'all' || t.dataset.cat === cat;
        var was = !t.hidden;
        t.hidden = !show;
        if (show) { shown++; if (!was && !reduced) { t.classList.add('is-entering'); nextFrame(function () { t.classList.remove('is-entering'); }); } }
      });
      empty.hidden = shown > 0;
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fli-cat]'); if (!b) return;
      applyFilter(b.dataset.fliCat);
    });

    /* ---------- Produktliste je Wirkstoff ---------- */
    function products(o) { return (o.products || []).filter(function (p) { return showDaily || p.key !== 'daily'; }); }
    function aggregateDose(o, p) {
      /* Ballaststoffe: Referenz gilt fuer die Summe -> Summe aller Ballaststoffe im Produkt */
      if (o.supply && o.supply.aggregate && o.cat === 'fibre') {
        var sum = 0;
        items.forEach(function (x) { if (x.cat === 'fibre') x.products.forEach(function (q) { if (q.key === p.key) sum += q.dose; }); });
        return sum;
      }
      return p.dose;
    }

    /* ---------- Bloecke ---------- */
    function block(kicker, title, inner, sub) {
      var b = h('section', 'fli__block');
      var head = h('div', 'fli__bhead');
      var left = h('div');
      left.appendChild(h('p', 'fli__bkicker', esc(kicker)));
      if (title) left.appendChild(h('h4', 'fli__btitle', esc(title)));
      head.appendChild(left);
      if (sub) head.appendChild(sub);
      b.appendChild(head);
      if (typeof inner === 'string') b.appendChild(h('div', null, inner)); else b.appendChild(inner);
      return b;
    }

    function renderProducts(o) {
      if (!products(o).length) return null;
      var wrap = h('div', 'fli__prods');
      products(o).forEach(function (p) {
        var a = h('a', 'fli__prod');
        a.href = (root.dataset.rootUrl === '/' ? '' : (root.dataset.rootUrl || '')) + '/products/' + p.handle;
        a.innerHTML = '<span class="fli__prod-name">' + esc(p.name) + '</span><span class="fli__prod-dose">' + esc(amt(p.dose, p.unit)) + ' <span style="color:var(--fli-mute)">' + esc(L.perDay) + '</span></span><span class="fli__prod-nrv">' + (p.nrv ? esc(p.nrv) + ' NRV' : '') + '</span>';
        wrap.appendChild(a);
      });
      if (o.doseNote) wrap.appendChild(h('p', 'fli__note', esc(o.doseNote)));
      return block(L.products, null, wrap);
    }

    function seg(labels, value, onChange) {
      var s = h('div', 'fli__seg');
      labels.forEach(function (l) {
        var b = h('button', 'fli__segbtn', esc(l.label)); b.type = 'button';
        b.setAttribute('aria-pressed', l.value === value ? 'true' : 'false');
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(s.querySelectorAll('.fli__segbtn'), function (button) {
            button.setAttribute('aria-pressed', button === b ? 'true' : 'false');
          });
          onChange(l.value);
        });
        s.appendChild(b);
      });
      return s;
    }

    function renderSupply(o) {
      var sp = o.supply;
      var prods = products(o);
      if (!sp && !prods.length) return null;
      var unit = sp ? sp.unit : (prods[0] && prods[0].unit) || '';
      var holder = h('div');
      var hasSex = sp && ((sp.ref && sp.ref.female !== sp.ref.male) || (sp.diet && sp.diet.female !== sp.diet.male));
      var sub = null;
      if (sp && (sp.ref || sp.diet)) {
        sub = seg([{ value: 'female', label: L.female }, { value: 'male', label: L.male }], sex, function (v) { sex = v; root.dataset.preselect = v; draw(); });
        if (!hasSex) sub = null;
      }
      var pk = pickKey[o.key] || (prods[0] && prods[0].key);

      function draw() {
        holder.innerHTML = '';
        var p = null; prods.forEach(function (q) { if (q.key === pk) p = q; }); if (!p) p = prods[0];
        var dose = p ? aggregateDose(o, p) : 0;
        var ref = sp && sp.ref ? sp.ref[sex] : null;
        var diet = sp && sp.diet ? sp.diet[sex] : null;
        var total = (diet || 0) + dose;

        if (prods.length > 1) {
          var pick = h('div', 'fli__pick');
          prods.forEach(function (q) {
            var b = h('button', 'fli__pickbtn', esc(q.name)); b.type = 'button';
            b.setAttribute('aria-pressed', q.key === p.key ? 'true' : 'false');
            b.addEventListener('click', function () { pickKey[o.key] = q.key; pk = q.key; draw(); });
            pick.appendChild(b);
          });
          holder.appendChild(pick);
        }

        /* Zahlen */
        var nums = h('div', 'fli__nums');
        if (sp && (sp.ref || sp.diet)) {
          nums.appendChild(h('div', 'fli__num', '<span class="fli__num-v">' + (diet != null ? fmt(diet) + '<small>' + esc(unit) + '</small>' : '<small>–</small>') + '</span><span class="fli__num-l">' + esc(L.diet) + '</span>'));
          nums.appendChild(h('div', 'fli__num fli__num--facts', '<span class="fli__num-v">+' + fmt(dose) + '<small>' + esc(unit) + '</small></span><span class="fli__num-l">' + esc(L.facts) + '</span>'));
          nums.appendChild(h('div', 'fli__num', '<span class="fli__num-v">' + (ref != null ? fmt(ref) + '<small>' + esc(unit) + '</small>' : '<small>–</small>') + '</span><span class="fli__num-l">' + esc(ref != null ? (sp.refLabel || L.ref) : L.ref) + '</span>'));
        } else {
          nums.appendChild(h('div', 'fli__num fli__num--facts', '<span class="fli__num-v">' + fmt(dose) + '<small>' + esc(unit) + '</small></span><span class="fli__num-l">' + esc(L.doseOnly) + '</span>'));
          nums.style.gridTemplateColumns = 'minmax(0,1fr)';
        }
        holder.appendChild(nums);

        /* Leiste 1: Gesamt am Tag */
        if (sp && (ref != null || diet != null)) {
          var ulTotal = (sp.ul != null && !sp.ulSupplementalOnly) ? sp.ul : null;
          var max = Math.max((ref || 0) * 1.35, total * 1.12, diet || 0);
          var ulOnAxis = ulTotal != null && ulTotal <= Math.max(ref || 0, total) * 4;
          if (ulOnAxis) max = Math.max(max, ulTotal * 1.06);
          var track = h('div', 'fli__track');
          track.appendChild(h('div', 'fli__track-l', '<span>' + esc(L.trackTotal) + '</span><b>' + esc(amt(total, unit)) + '</b>'));
          var bar = h('div', 'fli__bar' + (reduced ? '' : ' is-armed'));
          if (diet != null) { var sd = h('span', 'fli__seg-diet'); sd.style.setProperty('--w', pct(diet, max) + '%'); bar.appendChild(sd); }
          var so = h('span', 'fli__seg-dose' + (diet == null ? ' is-first' : '')); so.style.setProperty('--x', pct(diet || 0, max) + '%'); so.style.setProperty('--w', pct(dose, max) + '%');
          if (ulTotal != null && total > ulTotal) so.dataset.over = '1';
          bar.appendChild(so);
          var marks = h('div', 'fli__marks');
          if (ref != null) {
            var mk = h('span', 'fli__mark' + (total >= ref * REF_TOLERANCE ? ' fli__mark--soft' : '')); mk.style.setProperty('--x', pct(ref, max) + '%'); bar.appendChild(mk);
            var ml = h('span', 'fli__mlabel', esc(L.ref) + ' ' + esc(amt(ref, unit))); ml.style.setProperty('--x', pct(ref, max) + '%');
            if (pct(ref, max) < 18) ml.classList.add('is-left'); if (pct(ref, max) > 82) ml.classList.add('is-right');
            marks.appendChild(ml);
          }
          if (ulOnAxis) {
            var mu = h('span', 'fli__mark fli__mark--ul'); mu.style.setProperty('--x', pct(ulTotal, max) + '%'); bar.appendChild(mu);
            var mul = h('span', 'fli__mlabel is-right', 'EFSA ' + esc(amt(ulTotal, unit))); mul.style.setProperty('--x', pct(ulTotal, max) + '%'); marks.appendChild(mul);
          }
          track.appendChild(bar); track.appendChild(marks);
          var legend = h('div', 'fli__legend');
          if (diet != null) legend.appendChild(h('span', null, '<i style="background:#C9CDD3"></i>' + esc(L.diet)));
          legend.appendChild(h('span', null, '<i style="background:var(--fli-accent)"></i>' + esc(L.facts)));
          track.appendChild(legend);
          holder.appendChild(track);
          if (!reduced) nextFrame(function () { bar.classList.remove('is-armed'); });

          /* Einordnung */
          var v = h('div', 'fli__verdict');
          if (ref != null && diet != null) {
            if (total >= ref * REF_TOLERANCE) v.innerHTML = '<span class="fli__mark-dot" data-state="ok">' + CHECK + '</span><span>' + esc(L.refMet) + '</span>';
            else v.innerHTML = '<span class="fli__mark-dot">~</span><span>' + esc(L.refGap.replace('{gap}', amt(ref - total, unit))) + '</span>';
          } else if (ref != null) {
            v.innerHTML = '<span class="fli__mark-dot" data-state="none">–</span><span>' + esc(L.refNoDiet) + '</span>';
          } else {
            v.innerHTML = '<span class="fli__mark-dot" data-state="none">–</span><span>' + esc(L.noRef) + '</span>';
          }
          holder.appendChild(v);
          if (sp.aggregate) holder.appendChild(h('p', 'fli__note', esc(L.aggregateNote.replace('{agg}', sp.aggregate))));
        }

        /* Leiste 2: Nur die Ergaenzung (BfR, Gesetz, UL nur NEM) */
        var suppLines = [];
        if (sp && sp.bfr != null) suppLines.push({ v: sp.bfr, label: 'BfR', cls: '' });
        if (sp && sp.legal != null) suppLines.push({ v: sp.legal, label: 'EU', cls: 'fli__mark--ul' });
        if (sp && sp.ul != null && sp.ulSupplementalOnly) suppLines.push({ v: sp.ul, label: 'EFSA', cls: 'fli__mark--ul' });
        if (suppLines.length > 1) {
          var merged = [];
          suppLines.forEach(function (l) {
            var same = null; merged.forEach(function (m) { if (m.v === l.v) same = m; });
            if (same) { same.label += ' + ' + l.label; same.cls = same.cls || l.cls; } else merged.push({ v: l.v, label: l.label, cls: l.cls });
          });
          suppLines = merged;
        }
        if (suppLines.length && dose > 0) {
          var max2 = dose * 1.3;
          suppLines.forEach(function (l) { max2 = Math.max(max2, l.v * 1.18); });
          var t2 = h('div', 'fli__track');
          t2.appendChild(h('div', 'fli__track-l', '<span>' + esc(L.trackSupp) + '</span><b>' + esc(amt(dose, unit)) + '</b>'));
          var b2 = h('div', 'fli__bar' + (reduced ? '' : ' is-armed'));
          var s2 = h('span', 'fli__seg-dose is-first'); s2.style.setProperty('--x', '0%'); s2.style.setProperty('--w', pct(dose, max2) + '%');
          if (suppLines.some(function (l) { return l.cls && dose > l.v; })) s2.dataset.over = '1';
          b2.appendChild(s2);
          var m2 = h('div', 'fli__marks');
          suppLines.forEach(function (l) {
            var mk2 = h('span', 'fli__mark ' + l.cls); mk2.style.setProperty('--x', pct(l.v, max2) + '%'); b2.appendChild(mk2);
            var ml2 = h('span', 'fli__mlabel', esc(l.label) + ' ' + esc(amt(l.v, unit))); ml2.style.setProperty('--x', pct(l.v, max2) + '%');
            if (pct(l.v, max2) > 82) ml2.classList.add('is-right'); if (pct(l.v, max2) < 18) ml2.classList.add('is-left');
            m2.appendChild(ml2);
          });
          t2.appendChild(b2); t2.appendChild(m2);
          holder.appendChild(t2);
          if (!reduced) nextFrame(function () { b2.classList.remove('is-armed'); });
        }
      }
      draw();
      return block(L.supply, null, holder, sub);
    }

    function renderLimits(o) {
      if (!o.inDb) return null;
      var sp = o.supply; var prods = products(o);
      var wrap = h('div', 'fli__limits');
      var maxDose = 0; prods.forEach(function (p) { maxDose = Math.max(maxDose, aggregateDose(o, p)); });
      var unit = sp ? sp.unit : '';
      var rows = 0;
      function row(label, sub, value, state) {
        rows++;
        var r = h('div', 'fli__limit');
        r.innerHTML = '<span class="fli__limit-l">' + esc(label) + (sub ? '<span class="fli__limit-s">' + esc(sub) + '</span>' : '') + '</span><span class="fli__limit-v">' + esc(value) + (state ? '<span class="fli__pill" data-state="' + state + '">' + esc(state === 'ok' ? L.within : L.over) + '</span>' : '') + '</span>';
        wrap.appendChild(r);
      }
      if (sp) {
        if (sp.bfr != null) row(L.bfr, null, amt(sp.bfr, unit), maxDose <= sp.bfr ? 'ok' : 'over');
        if (sp.ul != null) {
          if (sp.ulSupplementalOnly) row(L.ulSupp, null, amt(sp.ul, unit), maxDose <= sp.ul ? 'ok' : 'over');
          else {
            var dietMax = sp.diet ? Math.max(sp.diet.female, sp.diet.male) : 0;
            row(L.ul, null, amt(sp.ul, unit), (dietMax + maxDose) <= sp.ul ? 'ok' : 'over');
          }
        }
        if (sp.legal != null) row(L.legal, null, amt(sp.legal, unit), maxDose <= sp.legal ? 'ok' : 'over');
      }
      if (!rows) row(L.noLimitRow, null, L.noLimit, null);
      if (sp && sp.context) wrap.appendChild(h('p', 'fli__note', esc(sp.context)));
      return block(L.limits, null, wrap);
    }

    function renderClaims(o) {
      var wrap = h('div');
      if (o.claimState === 'authorised') {
        var list = h('div', 'fli__claims');
        o.claims.forEach(function (c) {
          var refs = c.refs.map(function (r) { return 'EFSA Journal ' + r; }).join('; ');
          var m0 = (c.refs[0] || '').match(/^(\d{4});.*:(\d+)$/);
          var doi = m0 ? '10.2903/j.efsa.' + m0[1] + '.' + m0[2] : null;
          var link = doi ? '<a href="https://doi.org/' + esc(doi) + '" target="_blank" rel="noopener">' + esc(refs) + '</a>' : esc(refs);
          list.appendChild(h('div', 'fli__claim', '<span class="fli__claim-ic">' + CHECK + '</span><div><p class="fli__claim-t">' + esc(c.de) + '.</p>' + (c.cond ? '<p class="fli__claim-c">' + esc(c.cond) + '</p>' : '') + (link ? '<p class="fli__claim-r">' + link + '</p>' : '') + '</div>'));
        });
        wrap.appendChild(list);
        wrap.appendChild(h('p', 'fli__note', esc(L.claimsSub)));
      } else if (o.claimState === 'onhold' && o.onhold) {
        var de = L.onholdDe && L.onholdDe[o.key];
        wrap.appendChild(h('div', 'fli__onhold', esc(L.onholdLead) + '<q>' + esc(de || o.onhold.en) + '</q>'));
      } else {
        wrap.appendChild(h('div', 'fli__leer', esc(o.leer)));
      }
      return block(L.claims, null, wrap);
    }

    function renderSafety(o) {
      if (!o.safety || !o.safety.length) return null;
      var ul = h('ul', 'fli__safety');
      o.safety.forEach(function (t) { ul.appendChild(h('li', null, esc(t))); });
      return block(L.safety, null, ul);
    }

    function renderSources(o) {
      var src = o.sources.map(function (s) {
        if (typeof s === 'string') { var a = data.auth[s.slice(1)]; return a ? { kind: 'auth', label: a.label, ref: a.ref, url: a.url } : null; }
        if (s.k === 'e') {
          var mm = (s.d || '').match(/10\.2903\/j\.efsa\.(\d{4})\.(\d+)/);
          return { kind: 'efsa', label: s.n ? L.srcEfsaNeg : L.srcEfsaPos, ref: mm ? 'EFSA Journal ' + mm[1] + ', Nr. ' + mm[2] : '', doi: s.d };
        }
        return { kind: 'study', authors: s.a, year: s.y, title: s.t, journal: s.j, doi: s.d, cls: s.c };
      }).filter(function (s) {
        if (!s) return false;
        if (sourcesMode === 'efsa_only') return s.kind !== 'study' || s.cls === '2';
        return true;
      });
      if (!src.length) return null;
      var ol = h('ol', 'fli__src');
      src.forEach(function (s) {
        var html;
        if (s.kind === 'efsa') html = '<b>' + esc(s.label) + '</b>, ' + esc(s.ref) + '. ' + (s.doi ? '<a href="https://doi.org/' + esc(s.doi) + '" target="_blank" rel="noopener">doi:' + esc(s.doi) + '</a>' : '');
        else if (s.kind === 'auth') html = '<b>' + esc(s.label) + '</b>, ' + esc(s.ref) + '.' + (s.url ? ' <a href="' + esc(s.url) + '" target="_blank" rel="noopener">' + esc(s.url.replace(/^https?:\/\//, '')) + '</a>' : '');
        else html = '<b>' + esc(s.authors) + (s.year ? ' (' + s.year + ')' : '') + '</b>. ' + esc(s.title) + '. ' + esc(s.journal || '') + '. <a href="https://doi.org/' + esc(s.doi) + '" target="_blank" rel="noopener">doi:' + esc(s.doi) + '</a>';
        ol.appendChild(h('li', null, html));
      });
      var wrap = h('div');
      wrap.appendChild(ol);
      if (src.length > 3) {
        ol.dataset.collapsed = '1';
        var b = h('button', 'fli__srcbtn', esc(L.moreSources)); b.type = 'button';
        b.addEventListener('click', function () { var c = ol.dataset.collapsed === '1'; ol.dataset.collapsed = c ? '0' : '1'; b.textContent = c ? L.lessSources : L.moreSources; });
        wrap.appendChild(b);
      }
      return block(L.sources, null, wrap);
    }

    /* ---------- Lade ---------- */
    function render(key) {
      var o = byKey[key]; if (!o) return;
      openKey = key;
      var tile = grid.querySelector('[data-fli-tile="' + key + '"]');
      var img = tile && tile.querySelector('img');
      var src = (tile && tile.dataset.imgL) || (img && img.getAttribute('src'));
      dhero.innerHTML = src ? '<img src="' + esc(src) + '" alt="">' : '<span class="fli__ph" aria-hidden="true"><span class="fli__ph-mark">' + esc(o.name.charAt(0)) + '</span></span>';
      dcat.textContent = o.catLabel + (o.sub ? ' · ' + o.sub : '');
      dname.textContent = o.name;
      dform.textContent = o.form || '';
      dcontent.innerHTML = '';
      [renderProducts(o), o.what ? block(L.what, null, '<p class="fli__text">' + esc(o.what) + '</p>') : null, o.role ? block(L.role, null, '<p class="fli__text">' + esc(o.role) + '</p>') : null, renderSupply(o), renderLimits(o), renderClaims(o), renderSafety(o), renderSources(o)]
        .forEach(function (b) { if (b) dcontent.appendChild(b); });
      /* Navigation innerhalb des Filters */
      var vis = visibleTiles().map(function (t) { return t.dataset.fliTile; });
      var i = vis.indexOf(key);
      var prev = i > 0 ? vis[i - 1] : null, next = i >= 0 && i < vis.length - 1 ? vis[i + 1] : null;
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-fli-nav]'), function (b) {
        var dir = b.dataset.fliNav; var k = dir === '-1' ? prev : next;
        b.hidden = !k; b.dataset.target = k || '';
        var lab = b.querySelector('[data-fli-nav-label]'); if (lab && k) lab.textContent = byKey[k].name;
      });
      scroll.scrollTop = 0;
    }
    function open(key, fromTile) {
      lastFocus = fromTile || document.activeElement;
      render(key);
      root.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { drawer.focus(); }, 30);
    }
    function close() {
      root.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openKey = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    grid.addEventListener('click', function (e) {
      var t = e.target.closest('[data-fli-tile]'); if (!t) return;
      open(t.dataset.fliTile, t);
    });
    drawer.addEventListener('click', function (e) {
      var nb = e.target.closest('[data-fli-nav]');
      if (nb && nb.dataset.target) { render(nb.dataset.target); return; }
      if (e.target.closest('[data-fli-close]')) close();
    });
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!openKey) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') {
        var f = drawer.querySelectorAll('button:not([hidden]), a[href], [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    /* Wisch nach unten auf dem Sheet schliesst (nur am oberen Rand des Scrollbereichs) */
    var ty = null;
    drawer.addEventListener('touchstart', function (e) { ty = scroll.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    drawer.addEventListener('touchmove', function (e) { if (ty != null && e.touches[0].clientY - ty > 90) { ty = null; close(); } }, { passive: true });

    /* Deep link: #wirkstoff-<key> */
    var m = (location.hash || '').match(/^#wirkstoff-([a-z0-9_]+)$/);
    if (m && byKey[m[1]]) open(m[1]);

    /* Theme-Editor: Block in der Seitenleiste waehlen -> Steckbrief oeffnen, abwaehlen -> schliessen */
    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[data-fli-tile]') : null;
        if (!t || t.hidden) return;
        if (t.dataset.fliTile !== openKey) open(t.dataset.fliTile, t);
      });
      root.addEventListener('shopify:block:deselect', function () { if (openKey) close(); });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-fli]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-fli]'); if (r) init(r); });
})();
